{
  "ModalTitleAdd": "Aggiungi nuovo rapporto",
  "ModalTitleModify": "Modificare il rapporto",
  "ModalTitleDateTime": "Intervallo data\/ora",
  "TabnameReport": "Rapporto",
  "TabnameFilter": "Filtro",
  "TabnameOther": "Altro",
  "TabnameFields": "Campi",
  "TabnameDashboard": "Layout",
  "TabnameSlakpi": "SLA\/KPI",
  "TabnameAlarms": "Allarmi",
  "TabnameScheduling": "Programmazione",
  "TabnameAcdCodes": "Codici ACD",
  "TabnameFinancial": "Finanziario",
  "TabnameSettings": "Impostazioni",
  "TabnamePrint": "Stampa",
  "TabnameAdvanced": "Avanzato",
  "ReporttypelabelNolistitems": "Non ci sono voci dell'elenco corrente con questo nome.",
  "ConfigureReport_ButtonHelpLabel": "Aiuto?",
  "ConfigureReport_ButtonSubmitLabel": "OK",
  "ConfigureReport_ButtonCancelLabel": "Annullamento",
  "ConfigureReport_PromptMessage": "Siete sicuri di voler chiudere questa finestra? Tutte le configurazioni modificate andranno perse una volta chiuse.",
  "ConfigureReport_PromptConfirm": "Sì",
  "ConfigureReport_PromptCancel": "Annullamento",
  "ConfigureReport_Basic": "Base",
  "ConfigureReport_Advanced": "Avanzato",
  "NAME": "ConfigureReport"
}